import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getTables } from "../../api/table";
import { RESET } from "../types";

// Async thunk to load saloon tables
export const fetchSaloonTables = createAsyncThunk(
  "saloonTables/fetchSaloonTables",
  async (_, thunkAPI) => {
    try {
      const { data } = await getTables();

      // Order the data by items that have .order and .order.id
      return data.sort((a, b) => {
        if (a.order && a.order.order_id && (!b.order || !b.order.order_id)) {
          return -1;
        } else if (
          (!a.order || !a.order.order_id) &&
          b.order &&
          b.order.order_id
        ) {
          return 1;
        } else {
          return 0;
        }
      });
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// Initial state
const initialState = {
  tables: [],
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Slice
const saloonTablesSlice = createSlice({
  name: "saloonTables",
  initialState,
  reducers: {
    setStatus(state, action) {
      state.status = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSaloonTables.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSaloonTables.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.tables = action.payload;
      })
      .addCase(fetchSaloonTables.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(RESET, () => initialState);
  },
});

export const { setStatus } = saloonTablesSlice.actions;
export default saloonTablesSlice.reducer;
